

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.C7SVELr2.js","_app/immutable/chunks/disclose-version.BfHQzUcx.js","_app/immutable/chunks/index-client.HYok5wSr.js","_app/immutable/chunks/legacy.DG24rG7b.js","_app/immutable/chunks/render.BLNanXqs.js","_app/immutable/chunks/lifecycle.C79b4KUY.js","_app/immutable/chunks/entry.C-LI3Ywc.js"];
export const stylesheets = [];
export const fonts = [];
